module.exports = __webpack_public_path__ + "media/images/icons/flags/AU-d3595a115dbca02e882d519fe68d5040.svg";